import { computed, Ref, ref } from 'vue';
import { DocumentTemplateCategoryGroup } from '../../../shared/types/documentTemplate.types';
import type { MultiselectGroup, MultiselectOption } from '../../../shared/types/multiselect.types';
import i18n from '../../../shared/locales/i18n';

export const useTemplateFilter = (options: Ref<DocumentTemplateCategoryGroup[]>) => {
  const activeTemplateIds: Ref<number[]> = ref([]);
  const multiselectGroups: Ref<MultiselectGroup<MultiselectOption<string>>[]> = computed(() =>
    mapToMultiselectGroups(options.value)
  );

  const encode = (value: string) => encodeURIComponent(value);
  const optionId = {
    template: (category: string, title: string) => `cat=${encode(category)}|tpl=${encode(title)}`,
    noTemplate: (category: string) => `cat=${encode(category)}|noTpl=1`,
  };

  const toTemplateOption =
    (category: string) =>
    (title: string): MultiselectOption<string> => ({
      label: title,
      id: optionId.template(category, title),
      trackBy: `${category} ${title}`,
    });

  const noTemplateOption = (category: string): MultiselectOption<string> => ({
    label: i18n.t('document.no_template').toString(),
    id: optionId.noTemplate(category),
    trackBy: `${category} ${i18n.t('document.no_template').toString()}`,
    tag: `${i18n.t('document.no_template').toString()} (${category})`,
  });

  const mapToMultiselectGroups = (
    groups: DocumentTemplateCategoryGroup[]
  ): MultiselectGroup<MultiselectOption<string>>[] =>
    groups.map(group => ({
      label: group.category,
      options: [
        ...group.templateTitles.map(toTemplateOption(group.category)),
        ...(group.includeNoTemplate ? [noTemplateOption(group.category)] : []),
      ],
    }));

  return {
    activeTemplateIds,
    multiselectGroups,
  };
};
